import { render, staticRenderFns } from "./wordWatch.vue?vue&type=template&id=0715946c&scoped=true"
import script from "./wordWatch.vue?vue&type=script&lang=js"
export * from "./wordWatch.vue?vue&type=script&lang=js"
import style0 from "./wordWatch.vue?vue&type=style&index=0&id=0715946c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0715946c",
  null
  
)

export default component.exports